import { Permission } from '@cims-online/shared'
import { RestoreRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { simpleRestoreNotification } from 'hooks/notificationHandler'
import { useRestoreRfiOrganizationMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import {
  RFIOrganization,
  useOrganizationsTableContext,
} from '../../../../OrganizationsTableContext'

export function useRestoreOptions(): RestoreRowActionOptions<RFIOrganization> {
  const { refetch } = useOrganizationsTableContext()
  const [restoreOrganization] = useRestoreRfiOrganizationMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      restoreRFIOrganization: {
        organization: { name },
      },
    }) => simpleRestoreNotification(name),
  })
  return {
    permission: Permission.RemoveRestoreRFIOrganization,
    onRestore: async ({ id }) => {
      await restoreOrganization({ variables: { id } })
      refetch()
    },
    metadata: ({ deleted, deletedUser, deletedDate }) => ({
      removed: deleted,
      removedBy: deletedUser,
      removedDate: deletedDate,
    }),
    default: 'active',
  }
}
